import {ServiceBase} from "../ServiceBase";
import {IUserGameOrientation, IUserGameOrientationService} from "./user-game-orientation.service.interface";
import { action, observable, makeObservable } from "mobx";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {Check} from "@sparkware/app-utils";

const GAME_GROUP_COOKIE = "GameGroup";

export class UserGameOrientationService extends ServiceBase implements IUserGameOrientationService {

  @observable.ref
  public gameGroup: IUserGameOrientation = null;

  constructor(services: IServiceFactoryExtended){
    super(services);

    makeObservable(this);

    this._updateUserGameOrientation();

    this.reaction( () => this.services.user.isAuthorized,
      (isAuthorized) => isAuthorized && this._updateUserGameOrientation()
      )
  }

  @action.bound
  private _setUserOrientation(orientation:IUserGameOrientation) {
    this.gameGroup = orientation;
  }

  private async _updateUserGameOrientation(): Promise<void> {
    const userGameOrientationEnableConfig = this.services.configuration.servicesConfigs.User.enableUserGameOrientation;
    const enabled = Check.isNullOrUndefined(userGameOrientationEnableConfig) ? false : userGameOrientationEnableConfig;
    if(!enabled) {
      return;
    }

    const gameGroupCookie = this.services.cookies.getCookie(GAME_GROUP_COOKIE);
    if (gameGroupCookie){
      this._setUserOrientation(JSON.parse(gameGroupCookie));
    }

    if(this.services.user.isAuthorized) {
      let gameOrientation: IUserGameOrientation = await this.services.api.userController.getUserGameOrientation();
      if (gameOrientation?.groupId) {
        this._setUserOrientation(gameOrientation);
        this._setGameOrientationCookie(gameOrientation);
      }
    }
  }

  private _setGameOrientationCookie(orientation:IUserGameOrientation){
    let expirationDate:Date = new Date();
    expirationDate.setDate(expirationDate.getDate() + 1);
    this.services.cookies.createCookie(GAME_GROUP_COOKIE,JSON.stringify(orientation), expirationDate);
  }
}